__turbopack_context__.v({
  "left": "VerticalTabs-module-scss-module__zyl0kW__left",
  "tab": "VerticalTabs-module-scss-module__zyl0kW__tab",
  "tabsContainer": "VerticalTabs-module-scss-module__zyl0kW__tabsContainer",
});
